export default (filter) => {
  if (filter.selectedMaxValue) {
    return `${filter.selectedMinValue}-${filter.selectedMaxValue}`;
  }
  return filter.name || filter.text;
};
